<script lang="ts">

  import { cn } from "$lib/utils"
  import type { Snippet } from "svelte"

  let {
    label,
    active,
    onClick,
    children,
  }: {
    label: string
    active: boolean
    onClick: () => void
    children: Snippet
  } = $props()

</script>

<button
  type="button"
  class={cn("flex flex-col items-center justify-center px-3 py-2", active ? "text-primary" : "text-muted-foreground")}
  aria-current={active ? "page" : undefined}
  onclick={onClick}>
  {@render children()}
  <span class="mt-1 text-xs">{label}</span>
</button>
